import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWithWorksheetInjectedProps } from 'Components/Worksheets/Core';
import WorksheetStatus from 'Components/Worksheets/Core/WorksheetStatus';
import deepEquals from 'Lib/Object/deepEquals';
import React from 'react';
import { useSelector } from 'react-redux';
import './WorksheetBatchUpdateStatusDisplayField.scss';

/**
 * Provides a field for displaying the status of a worksheet
 */
let WorksheetBatchUpdateStatusDisplayField: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const status = useSelector(createWorksheetSelector!('header', false), deepEquals);
  return (
    <span className="WorksheetBatchUpdateStatusDisplayField-StatusIcon">
      <WorksheetStatus status={status} background="grey400" />
    </span>
  );
};

WorksheetBatchUpdateStatusDisplayField = withInjectedProps(WorksheetBatchUpdateStatusDisplayField);

export default WorksheetBatchUpdateStatusDisplayField;
export { WorksheetBatchUpdateStatusDisplayField };
